import styled, { css } from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
export const Gradient = styled.div `
  background: linear-gradient(184.6deg, #ededed -8.81%, #dddae0 60.04%, #e2ccc5 125.02%);
  background-blend-mode: multiply;
  color: ${newColors.gray800};
  height: 100%;
  width: 100%;
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 965px;
  padding: 90px 0px 140px 0px;
  margin: 0 auto;
  ${mediaq.lg `
     max-width: 825px;
     padding: 60px 0px 140px 0px;
  `}
  ${mediaq.md `
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 36px;
  max-width: 100%;
  `}
  ${mediaq.sm `
     gap: 24px;
     padding: ${(props) => `50px 0px ${props.applyOffset ? 120 : 40}px 0px`};
  `}
`;
export const EventIntroduction = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  ${mediaq.sm `
  gap: 8px;
  `}
`;
export const EventWelcomeMessage = styled.p `
  font-size: 18px;
  font-weight: 400;
  color: ${newColors.gray500};
  margin: 0;
  text-align: center;
  ${mediaq.sm `
  font-size: 14px;
  `}
`;
export const EventProse = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 2px;
  ${mediaq.sm `
  display: inline;
  max-width: 240px;
  `}
`;
export const EventParagraph = styled.span `
  color: ${(props) => (props.isLight ? newColors.gray500 : newColors.gray800)};
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  text-align: center;
  ${mediaq.sm `
  font-size: 14px;
  `}
`;
export const EventHeading = styled.h2 `
  font-family: 'Inria Serif';
  font-weight: 700;
  font-size: 40px;
  margin: 0;
  text-align: center;
  ${mediaq.lg `
  font-size: 32px;
  `}
  ${mediaq.md `
  white-space: normal;`}
  ${mediaq.sm `
  font-size: 24px;
  `}
`;
export const EventSubheading = styled.h3 `
  font-family: 'Inria Serif';
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  ${mediaq.lg `
  font-size: 18px;
  `}
  ${mediaq.sm `
  font-size: 16px;
  `}
`;
export const Separator = styled.div `
  background: ${newColors.snow};
  width: 70%;
  height: 2px;
  ${mediaq.md `
  display: none;
  `}
`;
export const EventPreview = styled.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  gap: 64px;
  > :first-child {
    display: none;
    ${mediaq.md `
    display: flex;
    `}
  }
  > :nth-child(3) {
    ${mediaq.md `
     display: none;
  `}
  }
  ${mediaq.md `
  gap: 36px;`}
`;
export const Image = styled.img `
  border-radius: 9999px;
  width: 330px;
  height: 330px;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  object-position: top center;

  ${mediaq.lg `
   width: 278px;
   height: 278px;
  `}

  ${mediaq.md `
   width: 198px;
   height: 198px;
  `}

  ${mediaq.sm `
   width: 140px;
   height: 140px;
  `}
`;
export const EventImage = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  object-fit: cover;
  object-position: top center;
  width: 362px;
  height: 362px;
  aspect-ratio: 1 / 1;
  background: #ebe9ec;

  ${mediaq.lg `
   width: 308px;
   height: 308px;
  `}

  ${mediaq.md `
   width: 218px;
   height: 218px;
  `}

  ${mediaq.sm `
   width: 156px;
   height: 156px;
  `}
`;
export const EventInfo = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  width: fit-content;
  gap: 40px;
  min-width: 605px;
  color: ${newColors.gray800};
  ${mediaq.lg `
  gap: 30px;
  min-width: 520px;
  `}

  ${(props) => props.hideLastChild &&
    css `
      > :last-child {
        display: none;
        ${mediaq.md `
    display: flex;
    `}
      }
    `}

  > :first-child {
    ${mediaq.md `
    display: none;
  `}
  }

  ${mediaq.sm `
  gap: 20px;
  min-width: auto;`}
`;
export const EventAction = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
`;
export const EventStatusInformation = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  background: ${newColors.purpleAlpha};
  padding: 18px 32px 18px 16px;
  border-radius: 16px;
  font-size: 14px;
  margin-top: auto;
  > svg > path {
    stroke: ${newColors.gray800};
  }
  ${mediaq.md `
  display: none;
  `}
`;
export const EventStartDatetime = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  line-height: 1;
  font-size: 18px;
  color: ${newColors.gray800};
  border-radius: 16px;
  > span {
    white-space: nowrap;
  }
  > svg {
    path {
      stroke: ${newColors.gray800};
    }
  }
  ${mediaq.sm `
  font-size: 14px;
  `}
`;
export const EventBody = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${(props) => (props.isCountdown ? '24px' : '4px')};
  ${mediaq.sm `
  max-width: 240px;
  `}
`;
export const WatchButton = styled.button `
  border: none;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  background: ${newColors.purple500};
  color: ${newColors.snow};
  font-size: 18px;
  font-weight: 500;
  padding: 12px 32px 12px 16px;
  border-radius: 9999px;
  gap: 14px;
  width: 285px;
  &:hover {
    background: ${newColors.gray500};
  }
  ${mediaq.sm `
  white-space: nowrap;
  font-size: 14px;
  width: 220px;
  padding: 8px 32px 8px 10px;
  `}
`;
export const PlayIcon = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${newColors.gray100};
  color: ${newColors.gray800};
  width: 45px;
  height: 45px;
  border-radius: 9999px;
  flex-shrink: 0;
  > svg {
    margin-left: 2px;
  }
  ${mediaq.sm `
  width: 38px;
  height: 38px;
  > svg {
  transform: scale(.85)
  }
  `}
`;
export const TestAudioButton = styled.button `
  border: none;
  font-family: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  gap: 12px;
  justify-content: center;
  align-items: center;
  background: ${newColors.snow};
  color: ${newColors.purple500};
  font-size: 14px;
  font-weight: 500;
  padding: 18px 32px;
  border-radius: 9999px;
  box-shadow: 0px 4px 26px 0px ${newColors.darkBlackAlpha}, inset 0 0 0 2px ${newColors.gray400},
    inset 0 0 0 4px transparent;

  &:hover {
    box-shadow: 0px 6px 26px 0px ${newColors.darkBlackAlpha}, inset 0 0 0 2px #b9b5bc,
      inset 0 0 0 4px #b9b5bc;
  }
`;
export const EventStatusBanner = styled.div `
  display: none;
  ${mediaq.md `
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0px 40px;
    gap: 14px;
    height: 60px;
    background: ${newColors.purple500};
    color: white;
    font-weight: 500;
    font-size: 14px;
    > svg > path {
      stroke: ${newColors.snow}
    }
    > span {
    max-width: 100%;
    }
  `}
  ${mediaq.sm `
    padding: 0px 12px;
    > span {
     max-width: 235px;
     white-space: pre-line;
    }
  `}
`;
